<template lang="pug">
div
    el-dialog(
        :visible='show',
        width='50%',
        :close-on-click-modal='false',
        :fullscreen='false',
        :before-close='closeModalSolicitacaoLaudo',
        append-to-body,
        destroy-on-close
    )
        span(slot='title')
            .title-area
                i.mdi.mdi-alert-circle-outline.title-area__icon
                h1 {{ this.$t('mensagens.subEmpresaGestao.modalSolicitacaoLaudo.embargo') }}
        .container-content.modal-solicitacao-laudo-enviar
            p
                | {{ this.$t('mensagens.subEmpresaGestao.modalSolicitacaoLaudo.imovelPossui') }}
                | <strong>{{ this.$t(possuiPontoAreaEmbargada ? 'mensagens.subEmpresaGestao.modalSolicitacaoLaudo.ponto' : 'mensagens.subEmpresaGestao.modalSolicitacaoLaudo.poligono') }}</strong>,
                | {{ this.$t('mensagens.subEmpresaGestao.modalSolicitacaoLaudo.possibilidadeRestricao') }}.
                | {{ this.$t('mensagens.subEmpresaGestao.modalSolicitacaoLaudo.podeSolicitarLaudo') }}
            p(v-if='possuiPontoAreaEmbargada')
                | {{ this.$t('mensagens.subEmpresaGestao.modalSolicitacaoLaudo.analiseDetalhada') }}

            el-upload.upload-input(
                v-if='possuiPontoAreaEmbargada',
                action='#',
                drag,
                :file-list='fileList',
                :limit='1',
                :on-exceed='handleExceed',
                :auto-upload='false',
                accept='.pdf',
                :on-change='setFile',
                :on-remove='removeFile',
                ref='upload'
            )
                i.el-icon-upload
                .el-upload__text.w-100 {{ this.$t('mensagens.subEmpresaGestao.modalSolicitacaoLaudo.arrasteArquivo') }} <em>{{ this.$t('mensagens.subEmpresaGestao.modalSolicitacaoLaudo.cliqueParaSubir') }}</em>
            p
                | {{ this.$t('mensagens.subEmpresaGestao.modalSolicitacaoLaudo.resultadoEmTresDias') }}
        .buttons-area
            el-button(
                slot='footer',
                size='medium',
                @click='closeModalSolicitacaoLaudo'
            ) {{ this.$t('mensagens.subEmpresaGestao.modalselecionarcarscpfcnpj.voltar') }}
            el-button(
                slot='footer',
                size='medium',
                type='primary',
                :loading='loadingSolicitacaoLaudo',
                @click='solicitarLaudo'
            ) {{ this.$t('mensagens.subEmpresaGestao.modalSolicitacaoLaudo.solicitarLaudo') }}
</template>

<script>
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';

export default {
    name: 'ModalSolicitacaoLaudo',
    props: {
        show: {
            type: Boolean,
            required: true
        },
        possuiPontoAreaEmbargada: {
            type: Boolean,
            required: true
        },
        idTerritorioSelecionado: {
            type: Number,
            required: false
        },
        carSelecionado: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            loadingSolicitacaoLaudo: false,
            file: null,
            fileList: []
        };
    },
    methods: {
        closeModalSolicitacaoLaudo() {
            this.resetFields();
            this.$emit('closeModalSolicitacaoLaudo');
        },
        handleExceed() {
            this.$notify.warning(
                this.$t(
                    'mensagens.subEmpresaGestao.modalSolicitacaoLaudo.apenasUmArquivo'
                )
            );
        },
        setFile(file) {
            this.file = file;
        },
        removeFile() {
            this.file = null;
        },
        resetFields() {
            this.file = null;
            this.fileList = [];
        },
        async solicitarLaudo() {
            if (this.possuiPontoAreaEmbargada && !this.file) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.subEmpresaGestao.modalSolicitacaoLaudo.insiraUmArquivo'
                    )
                );
                return;
            }

            this.loadingSolicitacaoLaudo = true;

            try {
                const response =
                    await ContratoOriginacaoServiceSubEmpresa.solicitarLaudoElegibilidade(
                        this.idTerritorioSelecionado,
                        this.$route.params.numeroContrato,
                        this.carSelecionado,
                        this.file
                    );

                this.$notify.success({
                    message: response.data
                });

                this.closeModalSolicitacaoLaudo();
                this.$emit('atualizarTabela');
            } catch (error) {
                this.$notify.error({
                    message: error.response.data.message
                });
            }

            this.loadingSolicitacaoLaudo = false;
        }
    }
};
</script>

<style lang="scss">
.el-dialog__header {
    background-color: #f6f6f6;

    .title-area {
        display: flex;
        gap: 10px;
        align-items: center;

        .title-area__icon {
            font-size: 26px;
        }

        h1 {
            font-size: 26px;
            font-weight: bold;
        }

        h1,
        .title-area__icon {
            color: $warning;
        }
    }

    .el-dialog__close.el-icon.el-icon-close {
        font-size: 26px;
    }
}

.upload-input {
    margin-bottom: 10px;
}

.buttons-area {
    display: flex;
    justify-content: flex-end;
}
.modal-solicitacao-laudo-enviar p {
    word-break: break-word;
}
</style>
